module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-info btn-robot-setting-save pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifySetting
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "robot-setting-content"
  }, [_vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskStartSetting),
      expression: "taskStartSetting"
    }],
    staticClass: "form-control robot-setting-input",
    attrs: {
      "placeholder": "Task starts..."
    },
    domProps: {
      "value": (_vm.taskStartSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskStartSetting = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "robot-setting-content"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskEndSetting),
      expression: "taskEndSetting"
    }],
    staticClass: "form-control robot-setting-input",
    attrs: {
      "placeholder": "Task completed..."
    },
    domProps: {
      "value": (_vm.taskEndSetting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskEndSetting = $event.target.value
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v("   Notification of  "), _c('strong', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("TASK START")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v("   Notification of  "), _c('strong', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("TASK COMPLETION")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a964784", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a964784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/GeneralSetting.vue
// module id = 462
// module chunks = 1